import React, { createContext, useReducer, useContext, useMemo } from 'react';

export const ModalContext = createContext(null);
export const ModalDispatchContext = createContext(null);

const initialModal = {
	isOpen: false,
	hasCloseBtn: false,
	title: '',
	subtitle: '',
	okText: '확인',
	cancelText: '취소',
	enlog: {},
	onClickOk: () => {},
	onClickCancel: () => {},
};

function modalReducer(modal, action) {
	switch (action.type) {
		case 'OPEN_MODAL': {
			const { title, subtitle, okText, onClickOk, onClickCancel, enlog } = action;
			return {
				...modal,
				enlog,
				isOpen: true,
				title,
				subtitle,
				okText,
				onClickOk,
				onClickCancel,
			};
		}

		case 'OPEN_DIALOG': {
			const { title, okText, onClickOk, enlog } = action;
			return {
				...modal,
				enlog,
				isOpen: true,
				title,
				okText,
				onClickOk,
				onClickCancel: null,
			};
		}

		case 'CLOSE': {
			const { enlog } = action;
			return {
				...initialModal,
				enlog,
				isOpen: false,
			};
		}

		default: {
			throw Error(`Unknown action: ${action.type}`);
		}
	}
}

export const ModalProvider = ({ children }) => {
	const [modal, dispatch] = useReducer(modalReducer, initialModal);
	const modalState = useMemo(() => modal, [modal]); // context 최적화
	return <ModalContext.Provider value={{ modal: modalState, dispatchModal: dispatch }}>{children}</ModalContext.Provider>;
};

export const useModal = () => useContext(ModalContext);

export default ModalProvider;

